/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2083
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.TOOLBOX_POSITION = exports.DeleteArea = undefined;
(function (e) {
  e[e.DELETE_AREA_NONE = 0] = "DELETE_AREA_NONE"
  e[e.DELETE_AREA_TOOLBOX = 2] = "DELETE_AREA_TOOLBOX"
})(exports.DeleteArea || (exports.DeleteArea = {}));
(function (e) {
  e[e.TOP = 0] = "TOP"
  e[e.BOTTOM = 1] = "BOTTOM"
  e[e.LEFT = 2] = "LEFT"
  e[e.RIGHT = 3] = "RIGHT"
})(exports.TOOLBOX_POSITION || (exports.TOOLBOX_POSITION = {}))
